const onlyData = data => {
  if (!data) {
    return {};
  }

  const { __typename, ...rest } = data;
  return { ...rest };
};

export default onlyData;
